import { useLang } from '@/lib/LanguageContext';

const stats = [
  { value: '21', label: 'Ventures Built' },
  { value: '9', label: 'Core Services' },
  { value: '2024', label: 'Established' },
  { value: 'Dubai', label: 'Silicon Oasis, UAE' }
];

export default function ProofSection() {
  const { t } = useLang();
  return (
    <section className="relative py-24 px-6 lg:px-8 border-y border-border/30">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="font-inter font-black text-3xl md:text-5xl tracking-[-0.03em] text-foreground">{t('Built. Deployed. Validated.')}</h2>
        <p className="mt-4 text-muted-foreground font-inter font-light">{t('Not concepts. Technology we have actually designed, engineered and launched.')}</p>
        <dl className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((s) => (
            <div key={s.label}>
              <dt className="sr-only">{t(s.label)}</dt>
              <dd className="font-inter font-black text-4xl md:text-5xl text-primary">{s.value}</dd>
              <dd className="mt-2 text-xs font-inter tracking-[0.2em] uppercase text-muted-foreground">{t(s.label)}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}